import { formatOptionQuantityLabel, getItemFractionBase, getVisibleOptions } from "@/lib/order-item-display"
import type { OrderResponse } from "@/types/external"
import type { OrderItemLineProps } from "./OrderItemLine"

type OrderItem = OrderResponse["items"][number]

type Options = {
  withImage?: boolean
  optionQuantitySuffix?: string
  scaleOptionPrices?: boolean
  hideFreePrice?: boolean
}

/** Maps an order item to `OrderItemLine` props, ordering and labelling its visible options. */
export function toOrderItemLineProps(
  item: OrderItem,
  { withImage = false, optionQuantitySuffix = "", scaleOptionPrices = false, hideFreePrice = false }: Options = {},
): OrderItemLineProps {
  const fractionBase = getItemFractionBase(item.options)
  const optionScale = scaleOptionPrices && item.quantity > 1 ? item.quantity : 1

  return {
    name: item.name,
    quantity: item.quantity,
    price: hideFreePrice && !(item.totalPrice?.value > 0) ? undefined : item.totalPrice?.value,
    image: withImage ? { src: item.image?.link } : undefined,
    options: getVisibleOptions(item.options).map((option, position) => ({
      key: `${option.index ?? position}-${option.name}`,
      name: option.name,
      quantityLabel: formatOptionQuantityLabel(option.quantity, fractionBase, { integerSuffix: optionQuantitySuffix }),
      price: option.totalPrice ? option.totalPrice.value * optionScale : undefined,
    })),
  }
}
